import ContactProfileImage from '@app/components/ContactProfileImage'
import InfiniteScrollTable from '@app/components/InfiniteScrollTable'
import { bindFunctions } from '@app/utils/class'
import { formatCurrency, formatKeyToReadableDate } from '@app/utils/formatting'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import {
  actionCreators,
  IProjectedProfitState,
} from '../modules/projectedProfit'

type ComponentProps = IProjectedProfitState & typeof actionCreators

export default class ProjectedProfitListPage extends React.PureComponent<
  ComponentProps
> {
  private tableRef: React.RefObject<InfiniteScrollTable>

  constructor(props: ComponentProps) {
    super(props)

    bindFunctions(this)

    this.tableRef = React.createRef<InfiniteScrollTable>()
  }

  public componentWillMount() {
    this.props.loadProjectedProfit(0, 20, false, undefined)
  }

  public renderReport() {
    if (!this.props.items) {
      return null
    }

    // const items: any = []
    let profitTotal: number = 0

    const items: any[] = []

    this.props.items.forEach((value, key) => {
      profitTotal = 0

      if (value === undefined || key === undefined) {
        return
      }

      items.push(
        <div key={key}>
          <div
            className='mt-3'
            style={{ fontWeight: 'bold', borderBottom: '1px solid #ccc' }}
          >
            {formatKeyToReadableDate(key)}
          </div>
          {value.map((projPipeline, index) => {
            profitTotal += projPipeline.profit.potentialProfit

            return (
              <div
                key={`projected-${index}`}
                className='d-flex flex-row justify-content-between my-2'
              >
                <div>
                  <ContactProfileImage
                    contact={projPipeline.user.contactId}
                    size={30}
                  />
                </div>
                <div className='mr-auto ml-4'>{projPipeline.user.name}</div>
                <div>
                  {formatCurrency(projPipeline.profit.potentialProfit, 2)}
                </div>
              </div>
            )
          })}
          <div
            style={{ fontWeight: 'bold' }}
            className='d-flex flex-row justify-content-between my-2'
          >
            <div style={{ width: 30 }} />
            <div className='mr-auto ml-4'>Total</div>
            <div>{formatCurrency(profitTotal, 2)}</div>
          </div>
        </div>,
      )
    })

    return items
  }

  public render() {
    return (
      <DocumentTitle title='Admin - Projected Profit'>
        <div className='container d-flex flex-column h-100 pt-3'>
          <div>
            <h3>Projected Profit Summary</h3>
          </div>
          <div className='mt-4'>{this.renderReport()}</div>
        </div>
      </DocumentTitle>
    )
  }

  private _noRowsRenderer() {
    return <div>No projected profits</div>
  }

  private _onChangeFilter(newFilter: string) {
    this.props.setFilterText(newFilter)
    this._reloadData()
  }

  private _reloadData() {
    if (this.tableRef.current) {
      this.tableRef.current.forceReloadData()
    }
  }
}
